module.exports = __webpack_public_path__ + "img/whitecamo.47866700.jpg";